<template>
    <div id="toolbar-card-list-item"
         class="tw-flex tw-items-center"
    >
        <img class="tw-w-7 tw-h-7 tw-mr-3 tw-rounded-full tw-bg-gray-400" :src="parsed_participant.user.picture_80"
             alt="avatar of user"/>
        <div class="tw-flex-grow">
            <span class="tw-text-black tw-text-sm tw-pr-5 tw-self-center typography">{{parsed_participant.user.firstname + ' ' + parsed_participant.user.lastname }}</span>
            <div v-if="is_co_host || has_pending_invite" class="tw-flex tw-items-center">
                <template v-if="is_co_host">
                    <i class="far fa-xs fa-user-crown tw-text-blue-500 tw-mr-1 tw-translate-y-px " />
                    <span class="tw-text-xs tw-text-blue-500 tw-pr-5">Co-host</span>
                </template>
                <template v-else>
                    <i class="far fa-sm fa-envelope tw-text-gray-400 tw-mr-1 tw-translate-y-px" />
                    <span class="tw-text-xs tw-text-gray-400 tw-pr-5">{{ $t('live.sent_co_host_request') }}</span>
                </template>
            </div>
        </div>
        <div v-if="room_admin" v-tooltip="reached_max_hosts && !is_co_host ? $t('live.reached_max_hosts') : null"
             @click="disable_click ? null : $emit('iconClicked')">
            <i class="far fa-sm tw-self-center tw-flex tw-items-center tw-justify-center tw-rounded-full tw-h-10 tw-w-10 tw-cursor-pointer hover:tw-bg-blue-100 active:tw-bg-blue-200"
               :class="icon_class"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: "ToolbarCardParticipantItem",
    props: {
        participant: {
            required: true,
        },
        reached_max_hosts: {
            default: false,
            type: Boolean,
        },
        has_pending_invite: {
            default: false,
            type: Boolean,
        },
       room_admin: {
            default: false,
            type: Boolean,
        }
    },
    computed: {
        disable_click() {
            return this.reached_max_hosts && !this.is_co_host;
        },
        is_co_host() {
            if (!this.participant) {
                return;
            }
            return this.participant.permissions.canPublish;
        },
        icon_class() {
            if (this.has_pending_invite){
                return 'fa-times-circle'
            } else if (this.is_co_host) {
                return 'fa-user-minus';
            } else if (!this.is_co_host && this.reached_max_hosts) {
                return 'fa-user-plus disabled-color-icon tw-pointer-events-none';
            } else {
                return 'fa-user-plus';
            }
        },
        parsed_participant() {
            if (!this.participant.metadata) {
                return;
            }
            return JSON.parse(this.participant.metadata);
        },
    },
}
</script>

<style scoped>
.disabled-color-icon {
    color: #C7C7C7;
}

.typography {
    font-weight: 400;
    font-size: 0.857rem;
}
</style>
